module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v("Message from UNIT Innovations,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n              Hello " + _vm._s(this.$store.state.usermain.curOrg.name) + ", "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              We are deploying a new Corrections Inventory System! Below are some features "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              1. Mobile and web based inventory system "), _c('br'), _vm._v("\n              2. Custom Sensors, Barcode, QR Codes, or IDs for Tagging "), _c('br'), _vm._v("\n              3. Tailored for corrections with check in, check out, issuance, and more "), _c('br'), _vm._v("\n              4. Safe staff time and improve productivity "), _c('br'), _vm._v("\n              5. Improve accountability, compliance, and reimbursements for quick ROI "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("If you are interested in bringing our latest offering to your facility contact your account representative for an early 2021 existing client discount. ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              If you need any other technology solutions reach out to us to see how we can help.\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Click "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://premises.support.unitdynamic.com"
    }
  }, [_vm._v("here")]), _vm._v(" to check out the support desk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc3f2be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 615
// module chunks = 1